import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import { VarianceContent } from '../../../Common/Table/tableContent';
import groupService from '../../../Group/services';
import divisionService from '../../../Devision/services';
import InputLabel from '@material-ui/core/InputLabel';
import $ from 'jquery';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPdf from "react-to-pdf";
import { CSVLink, CSVDownload } from "react-csv";
import TextField from '@material-ui/core/TextField';
import { VarianceSchemaObject } from '../VarianceSchema';
import { validateProperty, validate } from "../../../Common";
import services from '../../../Reports/VarianceReport/services';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = 'FIELDFACTORYVARIANCEREPORT';

export function VarianceListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [errors, setErrors] = useState({});
    const [isTableHide, setIsTableHide] = useState(true);
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);

    const schema = Joi.object(VarianceSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["estate", "division", "factory", "gtnNumber", "fieldName", "bagCountTN",
        "grossAmountTN", "deductionTN", "netAmountTN", "bagCountRN", "grossAmountRN",
        "deductionRN", "netAmountRN", "netVarience", "grossVariance"];
    const csvHeaders = [
        { label: "Estate", value: "estate" },
        { label: "Division", value: "division" },
        { label: "Factory", value: "factory" },
        { label: "GTN No", value: "gtnNumber" },
        { label: "Field", value: "fieldName" },
        { label: "Field Bag Count", value: "bagCountTN" },
        { label: "Field Gross", value: "grossAmountTN" },
        { label: "Field Deduction", value: "deductionTN" },
        { label: "Field Net", value: "netAmountTN" },
        { label: "Factory Bag Count", value: "bagCountRN" },
        { label: "Factory Gross", value: "grossAmountRN" },
        { label: "Factory Deduction", value: "deductionRN" },
        { label: "Factory Net", value: "netAmountRN" },
        { label: "Variance", value: "netVarience" },
        { label: "Gross Variance", value: "grossVariance" },
    ];

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [searchForm, setSearchForm] = useState({
        groupID: '0',
        estateID: '0',
        date: ''
    });
    const [resultData, setResultData] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({});
    const [csvData, setCsvData] = useState([]);

    useEffect(() => {
        trackPromise(
            getPermissions()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchForm.groupID])

    useEffect(() => {
        destroyDataTable();
        createDataTable();
    }, [resultData])

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await divisionService.getEstatesByGroupID(searchForm.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFIELDFACTORYVARIANCEREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropDown()
        );
    }

    async function handleSearch(e) {
        e.preventDefault();

        setIsTableHide(true);
        setIsReportButtonsEnabled(false);

        const errorMessages = validate(schema, searchForm);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        var result = await services.GetReportData(searchForm);

        if (result.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
            getSelectedDropdownValuesForReport(searchForm)
        }

        setReportDataForDisplay(result);
        generateCsvData(result);
    }

    function createFile() {
        var settings = {
            sheetName: 'Field Factory Variance',
            fileName: 'FieldFactoryVarianceReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            estate: "Group :" + groups[searchForm.groupID],
            division: "Estate : " + operationEntity[searchForm.estateID],
            factory: "Date : " + searchForm.date
        }
        copyOfCsv.push({}, {}, newRow1)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }


    function setReportDataForDisplay(data) {
        var resultArray = [];
        data.forEach(x => {
            resultArray.push({
                estate: x.estate,
                division: x.division,
                factory: x.factory,
                gtnNumber: x.gtnNumber,
                fieldName: x.fieldName,
                bagCountTN: x.bagCountTN,
                grossAmountTN: roundNumbers(x.grossAmountTN),
                deductionTN: roundNumbers(x.deductionTN),
                netAmountTN: roundNumbers(x.netAmountTN),
                bagCountRN: x.bagCountRN,
                grossAmountRN: roundNumbers(x.grossAmountRN),
                deductionRN: roundNumbers(x.deductionRN),
                netAmountRN: roundNumbers(x.netAmountRN),
                netVarience: roundNumbers(x.netVarience),
                grossVariance: roundNumbers(x.grossAmountTN - x.grossAmountRN)
            })
        });
        setResultData(resultArray);
    }

    function generateCsvData(data) {
        const newData = [...data];
        const newArray = [];
        newData.forEach(x => {
            var record = {
                estate: x.estate,
                division: x.division,
                factory: x.factory,
                gtnNumber: x.gtnNumber,
                fieldName: x.fieldName,
                bagCountTN: x.bagCountTN,
                grossAmountTN: roundNumbers(x.grossAmountTN),
                deductionTN: roundNumbers(x.deductionTN),
                netAmountTN: roundNumbers(x.netAmountTN),
                bagCountRN: x.bagCountRN,
                grossAmountRN: roundNumbers(x.grossAmountRN),
                deductionRN: roundNumbers(x.deductionRN),
                netAmountRN: roundNumbers(x.netAmountRN),
                netVarience: roundNumbers(x.netVarience),
                grossVariance: roundNumbers(x.grossAmountTN - x.grossAmountRN)
            }
            newArray.push(record);
        });
        setCsvData(newArray);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, VarianceSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setSearchForm({
            ...searchForm,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: operationEntity[searchForm.estateID],
            date: searchForm.date
        })
    }

    function roundNumbers(number) {
        return (Math.round(number * 100) / 100).toFixed(2);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12 card">
                    <div>
                        <PageHeader
                            title="Field Factory Variance Report"
                        />
                        <div className="card-body">
                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchForm.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select fullWidth
                                            id="estateID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="estateID"
                                            value={searchForm.estateID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["estateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="date">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>

                                <input
                                    type="submit"
                                    disabled={validate(schema, searchForm)}
                                    className="btn btn-primary"
                                    value="Generate"
                                />

                                {isTableHide ? null :
                                    <div>
                                        <div className="table-responsive row-top-gap">
                                            <div className="card shadow-none bg-light">
                                                <div className="card-body">
                                                    <table
                                                        id="example"
                                                        className="display dataTable">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan="5"></th>
                                                                <th colSpan="4" style={{ background: "lightgreen" }}>Field</th>
                                                                <th colSpan="4" style={{ background: "lightyellow" }}>Factory</th>
                                                                <th colSpan="2">Variance</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Estate</th>
                                                                <th>Division</th>
                                                                <th>Factory</th>
                                                                <th>GTN No</th>
                                                                <th>Field</th>
                                                                <th>Bag Count</th>
                                                                <th>Gross</th>
                                                                <th>Deduction</th>
                                                                <th>Net</th>
                                                                <th>Bag Count</th>
                                                                <th>Gross</th>
                                                                <th>Deduction</th>
                                                                <th>Net</th>
                                                                <th>Net Variance</th>
                                                                <th>Gross Variance</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <VarianceContent
                                                                data={resultData}
                                                                contentRowNames={contentRowNames}
                                                                hasEdit={false}
                                                            />
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        {!isReportButtonsEnabled ? null :
                                            <div className="pt-2">
                                                <ReactToPrint
                                                    documentTitle={"Field Factory Variance Report"}
                                                    trigger={() => <input
                                                        type="button"
                                                        className="btn btn-primary pull-right ml-2"
                                                        value="Create PDF"
                                                    />}
                                                    content={() => componentRef.current}
                                                />
                                                <div hidden={true}>
                                                    <CreatePdf ref={componentRef} data={resultData} rowNames={contentRowNames}
                                                        searchData={selectedSearchValues} />
                                                </div>
                                                <input
                                                    type="button"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="Excel"
                                                    onClick={createFile}
                                                />
                                            </div>}
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


